
export function isRequestParameters(o: any): boolean { return !!o._isRequestParameters; }

export default class RequestParameters {
    public _isRequestParameters: boolean;

    _parameters: {};
    _defaults: {};

    private static addTo(target: {}, params: {}) {
        Object.keys(params).forEach( k => {
            let value = params[k];
            if (typeof value === 'string' && /^\s*$/.test(value))
                value = undefined;  // string was blank

            if (value !== undefined) {
                target[k] = value;
            }
        });
    }

    private static toPrimitive(value: any): any {
        if (Array.isArray(value)) {
            // ensure all elements of array are primitives
            return value.map( v => RequestParameters.toPrimitive(v));
        } else if ('object' === typeof value) {
            // convert objects to strings
            return value.toString();
        } else
            return value;
    }

    private static urlencode(value: any): string {
        if ('object' === typeof value) {
            return RequestParameters.urlencode( value.toString() );
        } else if ('string' === typeof value) {
            // convert objects to strings
            return encodeURIComponent(value.toString());
        } else
            return value;
    }

    constructor(...args: {}[]) {
        this._isRequestParameters = true;
        this._parameters = {};
        this._defaults = {};

        // all arguments to constructor are considered a map of parameters
        for (const arg in args) {
            if (typeof args[arg] === 'object')
                this.add(args[arg]);
        }
    }

    clear() {
        // clear existing parameters
        this._parameters = {};
    }

    add(params: {}) {
        // add parameters to existing set (or overwrite existing ones)
        RequestParameters.addTo(this._parameters, params);
        return this;
    }

    set(params: {}) {
        // clear existing parameters and set new ones
        this.clear();
        RequestParameters.addTo(this._parameters, params);
        return this;
    }

    defaults(params: {}) {
        RequestParameters.addTo(this._defaults, params);
    }

    blend() {
        // combine the defaults and parameters
        return {
            ...this._defaults,
            ...this._parameters
        };
    }

    primitive() {
        // combine the defaults and parameters and convert values to primitives
        const blended = this.blend();
        return Object.keys(blended).map( k => {
            let value = blended[k];
            return RequestParameters.toPrimitive(value);
        });
    }

    join(paramSep: string, keyValueSep: string = '=', arrayValueSep: string = ',', valueEncode?: (value: string) => string) {
        const blended = this.blend();
        return Object.keys(blended).map( k => {
            let value = RequestParameters.toPrimitive(blended[k]);
            if (Array.isArray(value)) {
                if (valueEncode !== undefined) {
                    // join while encoding each array element
                    value = value.map(v => valueEncode(v));
                }
                // array values are already url encoded so dont encode again
                return k + keyValueSep + value.join(arrayValueSep);
            }

            // output the value
            return (value !== undefined)
                ? k + keyValueSep + (valueEncode ? valueEncode(value) : value)
                : undefined;
        })
            .filter(v => v !== undefined)   // filter out undefined values
            .join(paramSep);    // join all values
    }

    queryString() {
        return this.join(
            '&',
            '=',
            ',',
            RequestParameters.urlencode
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/parameters.tsx